"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = useLDflexValue;

var _react = require("react");

var _useLDflex = _interopRequireWildcard(require("./useLDflex"));
/**
 * Evaluates the Solid LDflex expression into a single value.
 */


function useLDflexValue(expression) {
  var _ref = (0, _useLDflex.default)(expression, false),
      _ref2 = _slicedToArray(_ref, 1),
      value = _ref2[0];

  (0, _react.useDebugValue)(value, _useLDflex.toString);
  return value;
}